export default "__VITE_ASSET__CIa86zj3__"